<template>
  <div>
    <span v-if="!showDraftDetails">
      <h5 class="text-heading mt-3 mb-3 text-left" v-if="currentTab =='History' ">History</h5>
      <h5 class="text-heading mt-3 mb-3 text-left" v-else>Drafts</h5>
      <div class="input-group search-bar col-4 ml-4 mb-2 p-0">
        <div class="input-group-prepend">
          <span class="input-group-text pr-0">
            <img class="mr-2" src="@/assets/searchIcon.svg" />
          </span>
        </div>
        <input
          class="form-control border-left-0"
          placeholder="Search Feedback detail"
          v-model="partnerFeedbackFilterText"
          @keydown="feedbackSearch"
          @keyup="feedbackSearch"
        />
      </div>
      <div class="card m-3">
        <w-table
          :tableValue="FeedBackTable"
          :tableLoading="tableLoader"
          :filter="partnerFeedbackFilterText"
          :sourceFrom="`Feedback${currentTab}`"
          @getFeedbackNumber="feedbackViewMore($event)"
        />
      </div>
      <!-- <v-dialog
      v-model="dialog"
      :scrollable="true"
      fullscreen
      hide-overlay
      class="feedback-popover"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <div class="po-toolbar">
          <p class="toolbar-heading mt-2 ml-3">
            <img
              align="right"
              class="mr-4 mt-2 close-icon mb-2"
              src="@/assets/close.svg"
              @click="dialog = false"
            />
          </p>
        </div>
      </v-card>
      </v-dialog>-->
    </span>
    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="changeModalSuccess()"
    />
    <c-evaluation
      v-if="showDraftDetails"
      :poNumber="orderNumber"
      :vendorCode="vendorCode"
      :jobCode="jobCode"
      :companyCode="companyCode"
      :jobType="ordertype"
      :FeedbackStatus="currentTab"
      :documentNumber="documentNumberValue"
      @navigateBack="successReponse($event)"
    />
  </div>
</template>

<script>
import Radio from "../../widgets/Feedbackradio";
import Textarea from "../../widgets/FeedbackTextarea.vue";
import CustomTextInput from "../../widgets/CustomTextInput";
import textInput from "../../widgets/TextInput";
import widgetModal from "../../widgets/newModalWidget";
import loadingSpinner from "../../widgets/LoadingSpinner";
import partnertable from "../../widgets/partner-table";
import moment from "moment";
import partnerEvaluation from "./partnerEvaluation";
import { PartnerService } from "../../services/partnerService";
const partnerService = new PartnerService();
export default {
  props: ["currentTab", "companyCode", "vendorCode"],
  components: {
    "w-text-area": Textarea,
    "w-radio": Radio,
    "w-table": partnertable,
    "w-text-input": textInput,
    "w-modal": widgetModal,
    "w-loadingSpinner": loadingSpinner,
    "c-evaluation": partnerEvaluation
  },

  data() {
    return {
      loading: false,
      module: "financial",
      financialData: "",
      financialValue: [],
      financialStrength: "",
      financialOthers: "",
      financialmerge: "",
      orderNumber: "",
      ordertype: "",
      jobCode: "",
      documentNumberValue: "",
      getEvaluationData: [],
      modulesArray: [],
      panel: 0,
      triggerModal: false,
      lastResponse: "",
      alertModal: false,
      successModal: false,
      showDraftDetails: false,
      dialog: false,
      partnerFeedbackFilterText: "",
      FeedBackTable: {
        fields: [
          {
            key: "documnetNumber",
            label: "Feedback Number",
            thClass: "thclassleftwidth",
            tdClass: "text-left"
          },
          {
            key: "date",
            label: "Feedback Date",
            thClass: "thclassrightwidth",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "orderNumber",
            label: "Order Number",
            thClass: "thclassrightwidth",
            tdClass: "text-right"
          },
          {
            key: "jobCode",
            label: "Job Code",
            thClass: "thclassrightwidth",
            tdClass: "text-right"
          },
          {
            key: "showviewdetails",
            label: "",
            thClass: "thclassrightwidth",
            tdClass: "text-right"
          }
        ],
        items: []
      }
    };
  },

  created() {
    this.getPartnerFeedbackDetails();
  },

  methods: {
    getPartnerFeedbackDetails() {
      if (this.currentTab == "History") {
        partnerService.getFeedbackFormDetails().then(resp => {
          this.FeedBackTable.items = resp.response[0].history;
        });
      } else {
        partnerService.getFeedbackDraftDetails().then(resp => {
          this.FeedBackTable.items = resp.response[0].history;
        });
      }
    },
    feedbackSearch() {
      this.partnerFeedbackFilterText = this.partnerFeedbackFilterText;
    },
    feedbackViewMore(event) {
      this.showDraftDetails = true;
      this.orderNumber = event.orderNumber;
      this.ordertype = event.orderType;
      this.jobCode = event.jobCode;
      this.documentNumberValue = event.documnetNumber;
      this.loading = true;
      // partnerService
      //   .getFeedbackFormIndivualDetail(
      //     this.companyCode,
      //     event.jobCode,
      //     event.orderNumber,
      //     event.orderType,
      //     this.vendorCode
      //   )
      //   .then(resp => {
      //     if (resp.response) {
      //       this.loading = false;
      //       this.getEvaluationData = resp.response[0].modules;
      //       this.dialog = true;
      //     } else {
      //       this.loading = false;
      //       this.triggerModal = true;
      //       this.alertModal = true;
      //       this.lastResponse = resp.failureMessage;
      //     }
      //   });
    },
    successReponse(event) {
      this.showDraftDetails = false;
      this.$emit("navigateBack", event);
    },
    getDefaultTextValue(event) {
      console.log(event);
    },
    changeModalSuccess() {
      this.triggerModal = false;
      this.alertModal = false;
      this.successModal = false;
    }
  }
};
</script>

<style scoped>
.question-text {
  font-size: 16px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.text-heading {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #000000;
}
.text-subheading {
  font-size: 16px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  color: #000000;
}
.text-subheading-value {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  color: #000000;
}
.question-additional-text {
  font-size: 15px;
  font-weight: 500;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.card-additional-background {
  /* width: 774px;
  height: 90px; */
  border-radius: 2px;
  border: solid 1px #c3c3c3;
  background-color: #f8f8f8 !important;
}
.subTitleClass {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}
.text-input-feild {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: 500; /* font-style: italic; */
  text-align: left;
}
.cancel-button {
  border: solid 1px #707070;
  background-color: #ffffff;
  font-family: "Open Sans", sans-serif !important;
  color: #484848;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.po-toolbar {
  background-color: #6192b1;
  color: white;
  height: 50px !important;
}
.toolbar-heading {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  text-align: left;
  font-size: 22px;
}
.close-icon {
  cursor: pointer;
  -ms-transform: rotate(45deg); /* IE 9 */
  -webkit-transform: rotate(45deg); /* Safari 3-8 */
  transform: rotate(45deg);
}
.draft-button {
  border: solid 1px #0e5d84;
  background-color: #ffffff;
  font-family: "Open Sans", sans-serif !important;
  color: #0e5d84;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.submit-button {
  background-color: #0c5e9d;
  font-family: "Open Sans", sans-serif !important;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  outline: none;
}
.dottedBlack {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #000;
  float: left;
  margin-top: 6px;
}
.search-bar .input-group-prepend .input-group-text {
  height: 43px;
  border-radius: 0;
  font-family: "Source Sans Pro", sans-serif;
  border: 1px solid #ced4da;
  background: #f4f4f4;
  font-size: 15px;
  cursor: pointer;
}

.search-bar .form-control {
  height: 43px;
  border-radius: 0;
  border: 1px solid #ced4da;
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
}

.search-bar .form-control:focus {
  box-shadow: none;
}
</style>
<style>
.feedback-popover > div > .v-dialog--fullscreen > .v-card {
  max-height: 100% !important;
  min-width: 0% !important;
  margin: 0 !important;
  padding: 0 !important;
  margin-left: 29% !important;
  margin-top: 150px !important;
  overflow-x: hidden;
}
</style>

